module.exports = __webpack_public_path__ + "img/luxury.fb6d0ac.webp";